module.exports = __webpack_public_path__ + "img/03.故宫连理柏（杨树田-摄）.6a79d1d4.jpg";